"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundFileUtilities = void 0;
// Use static URLs copied by CopyPlugin to avoid bundling audio via loader
var FACESCAN_SUCCESSFUL_SOUND_FILE = "/facetec/audios/facescan_successful_sound_file.mp3";
var PLEASE_FRAME_YOUR_FACE_SOUND_FILE = "/facetec/audios/please_frame_your_face_sound_file.mp3";
var PLEASE_MOVE_CLOSER_SOUND_FILE = "/facetec/audios/please_move_closer_sound_file.mp3";
var PLEASE_PRESS_BUTTON_SOUND_FILE = "/facetec/audios/please_press_button_sound_file.mp3";
var PLEASE_RETRY_SOUND_FILE = "/facetec/audios/please_retry_sound_file.mp3";
var UPLOADING_SOUND_FILE = "/facetec/audios/uploading_sound_file.mp3";
var SoundFileUtilities = /** @class */ (function () {
    function SoundFileUtilities() {
        // Return the customization object updated with custom sound files
        this.setVocalGuidanceSoundFiles = function (currentCustomization) {
            currentCustomization.vocalGuidanceCustomization.pleaseFrameYourFaceInTheOvalSoundFile =
                PLEASE_FRAME_YOUR_FACE_SOUND_FILE;
            currentCustomization.vocalGuidanceCustomization.pleaseMoveCloserSoundFile =
                PLEASE_MOVE_CLOSER_SOUND_FILE;
            currentCustomization.vocalGuidanceCustomization.pleaseRetrySoundFile =
                PLEASE_RETRY_SOUND_FILE;
            currentCustomization.vocalGuidanceCustomization.uploadingSoundFile =
                UPLOADING_SOUND_FILE;
            currentCustomization.vocalGuidanceCustomization.facescanSuccessfulSoundFile =
                FACESCAN_SUCCESSFUL_SOUND_FILE;
            currentCustomization.vocalGuidanceCustomization.pleasePressTheButtonToStartSoundFile =
                PLEASE_PRESS_BUTTON_SOUND_FILE;
            return currentCustomization;
        };
    }
    return SoundFileUtilities;
}());
exports.SoundFileUtilities = SoundFileUtilities;
